let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eOkC6")).then(() => parcelRequire('7qZto'));